import styled from "styled-components";

export const ModalContent = styled.div<{}>`
  position: relative;

  height: 100vh;
  width: 100vw;

  // center everything
  display: flex;
  flex-direction: column;
  align-items: center;
`;
